<div class="container mt-4">
    <h3 class="mt-4 text-center m-3 boldtext">Transacción expirada</h3>
    <p class="text-center">
        Estimado usuario, la transacción ha expirado. Por favor, inténtalo nuevamente.
    </p>
</div>